import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fireDB } from "../../funcs/firebase";
import { doc, getDoc } from "firebase/firestore";
import { Button, Spin, Typography, Card, Avatar, Divider, message, Space } from 'antd';
import { ShareAltOutlined, CopyOutlined, LoginOutlined, UserOutlined, RobotOutlined, StarFilled, CheckCircleOutlined, LockOutlined } from '@ant-design/icons';
import '../login/main.css';

const { Title, Text, Paragraph } = Typography;

// ========================================
// TICKER DATA - Same as Login Page
// ========================================

const REVIEWS_DATA = [
    {
        text: "We have moved our business from",
        highlightText: " Manychat to InstantDM. I am getting the same product at one-third of the price",
        fullText: "I was paying to Manychat.",
        author: "Yogendra Nathany - Coach"
    },
    {
        text: "I have to say this is",
        highlightText: "one of the best automation app i have used",
        fullText: "instagram & facebook automation, and best part is the customer service that they provide.",
        author: "DULHAN JEWELS - Brand, Shopify & Retail"
    },
    {
        text: "Absolutely wonderful.",
        highlightText: "The best that I have found. Super helpful and super reasonable pricing",
        fullText: "Will stick around for sure, would highly recommend.",
        author: "Victor Vigil"
    },
    {
        text: "This platform is",
        highlightText: "very good and makes automation easy",
        fullText: "to understand and use.",
        author: "Avinash - Coach"
    },
    {
        text: "It has",
        highlightText: "simplified our communication process. The interface is user-friendly",
        fullText: "and the automation features help us respond faster and stay organized.",
        author: "Skill Radar - Coach"
    },
    {
        text: "I really like instantDM.",
        highlightText: "It has been very helpful and at such a great price.",
        fullText: "I highly recommend it.",
        author: "Mark Lee - Creator, Entrepreneur"
    },
    {
        text: "Very",
        highlightText: "easy to use, lot of great features",
        fullText: "and is very affordable.",
        author: "MENTSMART PRIVATE LIMITED - Business & Store"
    },
];

const CREATORS_DATA = [
    {
        image: "https://framerusercontent.com/images/k0bfRSzEQXeIQZd6I3DNGrepvQ0.jpg",
        name: "@yamahaindonesia",
        niches: ["Brand", "Retail Store"],
        followers: "1.5 Million+"
    },
    {
        image: "https://framerusercontent.com/images/TYactyMkUxAa6akdPDzudte2tSo.png",
        name: "artificialntellligence",
        niches: ["AI", "Community", "Education"],
        followers: "1.5 Million+"
    },
    {
        image: "https://framerusercontent.com/images/V1cGFdx7Nh5RAZoW2ua2BI6lpo4.png",
        name: "Kitchen Stories",
        niches: ["Food & Kitchen", "Community"],
        followers: "300K+"
    },
    {
        image: "https://framerusercontent.com/images/u1TqjUQtTA1JioKdRZ1F8qDg.png",
        name: "HCL GUVI",
        niches: ["Institution", "Career Guidance"],
        followers: "280K+"
    },
    {
        image: "https://framerusercontent.com/images/J4hlheRnQUXnK9mvy5NT9kisiFU.png",
        name: "DEBELLIN | TOP BRAND",
        niches: ["Brand", "Life Style"],
        followers: "260K+"
    },
    {
        image: "https://framerusercontent.com/images/0qrO9deXJDS7wAugY2eIpnxEJwE.png",
        name: "Mridul Madhok",
        niches: ["Influencer", "Youtuber"],
        followers: "3 Million+"
    },
    {
        image: "https://framerusercontent.com/images/DjvLzI1Wb9L9tYqRD0fI2N1FODk.png",
        name: "@jeemboombhaa",
        niches: ["Influencer", "Regional Creator"],
        followers: "2.2 Million+"
    },
    {
        image: "https://framerusercontent.com/images/sD2rjLg5BQwaQHaMzPpoliwDVMo.png",
        name: "@praveendheiveegan",
        niches: ["Influencer", "Regional Creator"],
        followers: "900K+"
    },
    {
        image: "https://framerusercontent.com/images/VFq765JQXZvmiIO589ROgdwS4.png",
        name: "Computer Coach & Excel Expert",
        niches: ["Guru", "Digital Seller"],
        followers: "1.4 Million+"
    },
    {
        image: "https://framerusercontent.com/images/vM4VWtAmiKZgu4geUZCr4czJg4.png",
        name: "hybridfitnessindia",
        niches: ["Trainer", "Fitness"],
        followers: "700K+"
    },
    {
        image: "https://framerusercontent.com/images/gFuFG1Hkmce4wQC9ecPt1iWmQa4.png",
        name: "Dulhan Jewels",
        niches: ["Retail Store", "Shopify"],
        followers: "227K+"
    },
];

export default function SharedFlowPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [templateData, setTemplateData] = useState(null);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            try {
                setUser(JSON.parse(userData));
            } catch (e) {
                console.error("Error parsing user data", e);
            }
        }

        const fetchTemplate = async () => {
            try {
                const docRef = doc(fireDB, "shared_templates", id);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setTemplateData({ id: docSnap.id, ...docSnap.data() });
                } else {
                    setError("Shared automation not found or has been removed.");
                }
            } catch (err) {
                console.error("Error fetching template:", err);
                setError("Failed to load automation details.");
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchTemplate();
    }, [id]);

    const handleCopy = () => {
        navigate(`/flow?shared_id=${id}`);
    };

    const handleLogin = () => {
        localStorage.setItem("pending_shared_template_id", id);
        localStorage.setItem("show_pending_shared_template", "true");
        navigate("/login");
    };

    if (loading) {
        return (
            <div className="auth-page" style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Spin size="large" tip="Loading automation..." />
            </div>
        );
    }

    if (error) {
        return (
            <div className="auth-page" style={{ justifyContent: 'center', alignItems: 'center' }}>
                <div className="auth-card" style={{ textAlign: 'center', maxWidth: 400 }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
                    <Title level={3}>Oops!</Title>
                    <Paragraph type="secondary">{error}</Paragraph>
                    <Button type="primary" onClick={() => navigate("/")} style={{ background: 'var(--auth-primary)' }}>Go Home</Button>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            {/* Left Side - Branding Panel */}
            <div className="auth-branding">
                <div className="floating-keywords">
                    <span className="floating-keyword" style={{ top: '12%', left: '8%', animationDelay: '0s' }}>Comment PP</span>
                    <span className="floating-keyword" style={{ top: '25%', right: '10%', animationDelay: '0.5s' }}>Comment Link</span>
                    <span className="floating-keyword" style={{ top: '45%', left: '5%', animationDelay: '1s' }}>Comment Price</span>
                    <span className="floating-keyword" style={{ bottom: '35%', right: '8%', animationDelay: '1.5s' }}>Comment Address</span>
                    <span className="floating-keyword" style={{ bottom: '20%', left: '12%', animationDelay: '2s' }}>Comment Location</span>
                    <span className="floating-keyword" style={{ top: '15%', right: '25%', animationDelay: '2.5s' }}>Comment PDF</span>
                    <span className="floating-keyword" style={{ bottom: '45%', left: '15%', animationDelay: '3s' }}>Comment Guide</span>
                    <span className="floating-keyword" style={{ bottom: '12%', right: '20%', animationDelay: '3.5s' }}>Comment AI</span>
                </div>

                <div className="branding-content">
                    <div className="partnership-logos">
                        <img src="/logo192.png" alt="InstantDM Logo" className="branding-logo" />
                        <span className="partnership-x">×</span>
                        <img src="https://framerusercontent.com/images/wXj9XrHIPCGnc982zfYTj9zNBg.png?width=526&height=273" alt="Meta Business Partner" className="meta-business-partner-logo" />
                    </div>
                    <h1 className="branding-title">
                        Shared Automation Flow
                    </h1>
                    <p className="branding-subtitle">
                        Copy this expert-designed automation to your workspace and start growing your business with InstantDM.
                    </p>

                    {/* Reviews Ticker */}
                    <div className="ticker-section">
                        <div className="ticker-container reviews-ticker">
                            <div className="ticker-track">
                                {[...Array(2)].map((_, setIndex) => (
                                    <div className="ticker-content" key={setIndex}>
                                        {REVIEWS_DATA.map((review, index) => (
                                            <div className="review-card" key={index}>
                                                <div className="review-stars">
                                                    <StarFilled /><StarFilled /><StarFilled /><StarFilled /><StarFilled />
                                                </div>
                                                <p className="review-text">
                                                    "{review.text}{review.text ? ' ' : ''}<span className="highlight">{review.highlightText}</span> {review.fullText}"
                                                </p>
                                                <span className="review-author">— {review.author}</span>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Creators Ticker */}
                    <div className="ticker-section creators-section">
                        <div className="ticker-container creators-ticker">
                            <div className="ticker-track ticker-reverse">
                                {[...Array(2)].map((_, setIndex) => (
                                    <div className="ticker-content" key={setIndex}>
                                        {CREATORS_DATA.map((creator, index) => (
                                            <div className="creator-card" key={index}>
                                                <div className="creator-image">
                                                    <img src={creator.image} alt={creator.name} />
                                                </div>
                                                <div className="creator-info">
                                                    <span className="creator-name">{creator.name}</span>
                                                    <div className="creator-niches">
                                                        {creator.niches.map((niche, nIndex) => (
                                                            <span className="niche-tag" key={nIndex}>{niche}</span>
                                                        ))}
                                                    </div>
                                                    <span className="creator-followers">{creator.followers} followers</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Side - Action Panel */}
            <div className="auth-form-panel">
                <div className="auth-card">
                    <div className="partnership-logos mobile-only">
                        <img src="/logo192.png" alt="InstantDM Logo" className="branding-logo" />
                        <span className="partnership-x">×</span>
                        <img src="https://framerusercontent.com/images/wXj9XrHIPCGnc982zfYTj9zNBg.png?width=526&height=273" alt="Meta Business Partner" className="meta-business-partner-logo" />
                    </div>

                    <div className="auth-header">
                        <Avatar
                            size={64}
                            icon={<RobotOutlined />}
                            style={{ backgroundColor: '#1890ff', marginBottom: 16 }}
                        />
                        <h2>{templateData.name || "Untitled Automation"}</h2>
                        <p>Shared by <strong>{templateData.author_name || templateData.author_email || "Anonymous Creator"}</strong></p>
                    </div>

                    {templateData.description && (
                        <div style={{ background: 'var(--auth-bg)', padding: '16px', borderRadius: 'var(--radius-md)', marginBottom: 24, textAlign: 'left', border: '1px solid var(--auth-border)' }}>
                            <Text type="secondary" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Description</Text>
                            <Paragraph style={{ margin: '8px 0 0 0', color: 'var(--auth-text)', fontSize: 13, lineHeight: '1.6' }}>
                                {templateData.description}
                            </Paragraph>
                        </div>
                    )}

                    {user ? (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ marginBottom: 20, padding: 8, background: 'rgba(24, 144, 255, 0.1)', borderRadius: 8, display: 'inline-block' }}>
                                <Text type="secondary" style={{ fontSize: 13, color: '#1890ff' }}>
                                    Logged in as <strong>{user.name || user.emailid}</strong>
                                </Text>
                            </div>
                            <Button
                                type="primary"
                                size="large"
                                className="auth-submit-btn"
                                icon={<CopyOutlined />}
                                onClick={handleCopy}
                                block
                            >
                                Copy as New Automation
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <Paragraph style={{ marginBottom: 24, fontSize: 14, color: 'var(--auth-text-muted)', textAlign: 'center' }}>
                                Login to InstantDM to copy this automation and start editing safely.
                            </Paragraph>
                            <Button
                                type="primary"
                                size="large"
                                className="auth-submit-btn"
                                icon={<LoginOutlined />}
                                onClick={handleLogin}
                                block
                            >
                                Login to Copy
                            </Button>
                            <div className="auth-footer" style={{ marginTop: 16 }}>
                                <Button className="auth-switch-btn" href="/signup">
                                    Don't have an account? Sign up
                                </Button>
                            </div>
                        </div>
                    )}

                    {/* Trust Badges */}
                    <div className="trust-badges auth-trust-badges" style={{ marginTop: 40 }}>
                        <img src="https://framerusercontent.com/images/c0o1mNbHLKhdEqHalSsh1qOJ8.webp?width=50&height=50" alt="Meta Partner" className="trust-badge" />
                        <img src="https://framerusercontent.com/images/MabHaaNcQ4teDx1Kd9uNrQUL1c.png?scale-down-to=512&width=558&height=125" alt="Instagram Partner" className="trust-badge" />
                        <img src="https://framerusercontent.com/images/OsRHaZK5SG3gj7UNjoPBIQQCw.svg?width=133&height=45" alt="App Store Partner" className="trust-badge" />
                        <img src="https://framerusercontent.com/images/BserlDMbsbbZLyzPNawjFV9MtY.svg?width=150&height=45" alt="Play Store Partner" className="trust-badge" />
                    </div>
                </div>
            </div>
        </div>
    );
}
